"use client";

import { ShieldCheck, Zap } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Identity() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.2
  });
  const {
    ref: pathRef,
    isVisible: pathVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.3
  });
  const {
    ref: circleRef,
    isVisible: circleVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.4
  });
  const pillars = [{
    icon: ShieldCheck,
    title: "Sicurezza impiantistica certificata.",
    bg: "bg-white",
    iconColor: "text-primary"
  }, {
    icon: Zap,
    title: "Efficienza energetica operativa.",
    bg: "bg-white",
    iconColor: "text-primary"
  }];
  return <section data-section-id="1310" ref={sectionRef} id="identità-e-visione-tecnica" className="bg-background text-foreground py-24 md:py-36 px-4 md:px-8 overflow-hidden relative">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div className="lg:col-span-5 relative">
            <div className={`relative w-full max-w-[420px] mx-auto h-[420px] md:h-[480px] transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              {}
              <div className="absolute inset-0 bg-white border border-border">
                <div className="absolute inset-0 flex items-center justify-center">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/tecnico_specializzato_dpi_robot_ispezione.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/tecnico_specializzato_dpi_robot_ispezione.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/tecnico_specializzato_dpi_robot_ispezione.png-wvc-sizes" alt="Tecnico specializzato durante ispezione robotizzata di condotti HVAC" loading="lazy" decoding="async" className="w-[280px] md:w-[340px] h-auto object-contain border border-border/40 rounded-lg shadow-lg" />
                </div>
              </div>

              {}
              <div className="absolute -top-6 -right-2 md:-right-6 w-[150px] md:w-[180px] h-[180px] md:h-[210px] bg-white border border-border overflow-hidden p-2">
                <div className="relative w-full h-full overflow-hidden">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_inox_professionale_dettaglio.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_inox_professionale_dettaglio.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/cappa_inox_professionale_dettaglio.png-wvc-sizes" alt="Dettaglio tecnico di cappa professionale in acciaio inox" loading="lazy" decoding="async" className="w-full h-full object-cover border border-border/40 rounded-lg shadow-lg" />
                </div>
              </div>

              {}
              <div className="absolute -bottom-4 -left-2 md:-left-6 px-5 py-3 bg-primary border border-primary">
                <p className="font-mono text-xs md:text-sm font-medium uppercase text-white" style={{
                letterSpacing: "0.18em"
              }}>
                  Aera
                </p>
              </div>

              {}
              <svg ref={pathRef} className="hidden lg:block absolute -bottom-20 -right-20 w-[200px] h-[120px] pointer-events-none" viewBox="0 0 200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20 Q 50 60, 90 40 T 170 80 Q 185 95, 195 110" stroke="var(--primary)" strokeWidth="1" strokeLinecap="round" strokeDasharray="8 6" fill="none" style={{
                strokeDashoffset: pathVisible ? 0 : 400,
                transition: "stroke-dashoffset 1200ms cubic-bezier(0.22, 1, 0.36, 1)"
              }} />
              </svg>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            {}
            <div className={`flex items-center gap-3 mb-6 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <span className="font-mono text-xs md:text-sm font-medium uppercase text-muted-foreground" style={{
              letterSpacing: "0.18em"
            }}>
                Divisione Tecnica garantisce interventi specialistici certificati
              </span>
              <span className="w-2 h-2 bg-primary" />
            </div>

            {}
            <h2 className={`font-default font-medium leading-[1.1] tracking-tight text-secondary mb-8 transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(2rem, 4.4vw, 3.75rem)"
          }}>
              Eccellenza nella{" "}
              <span className="relative inline-block">
                <em className="not-italic relative z-10 px-1 text-primary">riqualificazione</em>
                <svg ref={circleRef} className="absolute -inset-1 md:-inset-2 w-[calc(100%+1rem)] md:w-[calc(100%+2rem)] h-[calc(100%+0.5rem)] md:h-[calc(100%+1rem)] pointer-events-none" viewBox="0 0 120 60" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M 60 5 Q 100 5, 113 28 Q 118 50, 70 55 Q 20 58, 8 35 Q 5 12, 50 6 Q 80 4, 110 12" stroke="var(--primary)" strokeWidth="1" strokeLinecap="round" fill="none" strokeDasharray="300" style={{
                  strokeDashoffset: circleVisible ? 0 : 300,
                  transition: "stroke-dashoffset 600ms cubic-bezier(0.22, 1, 0.36, 1) 400ms"
                }} />
                </svg>
              </span>{" "}
              tecnica.
            </h2>

            {}
            <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-8 transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground">
                La divisione tecnica di Aera è il reparto tecnico-specialistico dedicato alla valutazione, pianificazione ed esecuzione di interventi complessi su sistemi aeraulici industriali e commerciali.
              </p>
              <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground">
                Attraverso ispezioni video avanzate e analisi critiche, definiamo piani operativi su misura per ogni struttura, garantendo una verifica finale documentata da report fotografici dettagliati prima e dopo l'intervento.
              </p>
            </div>

            {}
            <div className={`mb-10 transition-all duration-700 delay-400 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="font-default font-medium text-lg md:text-xl text-secondary">
                Direzione Tecnica Aera
              </p>
            </div>

            {}
            <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              {pillars.map((pillar, i) => {
              const Icon = pillar.icon;
              return <Card key={i} data-index={i} className="bg-card border border-border p-6 flex items-center gap-4 transition-transform duration-200 hover:-translate-y-0.5 rounded-lg shadow-md">
                    <div className={`shrink-0 w-12 h-12 ${pillar.bg} border border-border flex items-center justify-center`}>
                      <Icon className={`w-5 h-5 ${pillar.iconColor}`} strokeWidth={1.5} />
                    </div>
                    <p className="font-default text-lg md:text-xl font-medium text-foreground leading-tight">
                      {pillar.title}
                    </p>
                  </Card>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}